import { gateway } from "../../../../gateway";
import { sanitizeSearchQuery } from "../../../../utils/sanitizeSearchQuery";

interface Props {
  page: number;
  pageSize: number;
  clientUid?: string | null;
  search?: string;
  searchBy?: "id" | "name";
}

export const getAllMyJobs = async ({ page, pageSize, clientUid = null, search = "", searchBy = "name" }: Props) => {
  try {
    const token = sessionStorage.getItem("token");
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
    });

    if (clientUid) params.set("clientUid", clientUid);
    const cleanSearch = sanitizeSearchQuery(search).trim();
    if (cleanSearch) {
      params.set("search", cleanSearch);
      params.set("searchBy", searchBy);
    }

    const res = await gateway.get(`/jobs/self?${params.toString()}`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    return res.data || res.data?.data;
  } catch (error) {
    throw error;
  }
};
